<script setup lang="ts">
defineProps({ blok: Object });

const open = ref(false);
</script>

<template>
  <section class="section">
    <UiContainer>
      <div class="flex flex-wrap -m-12 max-[769px]:-m-3">
        <div class="w-5/12 p-12 max-[769px]:w-full max-[769px]:p-3">
          <div
            class="[&>h2]:font-eb-garamond [&>h2]:text-chsc-indigo-500 [&>h2]:fs-6xl [&>h2]:mb-8 [&>p]:fs-3xl [&>p]:font-eb-garamond [&>p]:mb-8 [&>p>a]:underline"
          >
            <StoryblokRichText :doc="blok?.description_left" />
          </div>
          <div>
            <UButton
              :label="blok?.privacy_text"
              variant="outline"
              trailing-icon="i-lucide-plus"
              @click="open = true"
            />
          </div>
        </div>
        <div class="w-7/12 p-12 max-[769px]:w-full max-[769px]:p-3">
          <div
            class="[&>p]:fs-3xl [&>p]:font-eb-garamond [&>p]:mb-8 [&>p>a]:underline [&>blockquote>p]:text-chsc-indigo-500 [&>blockquote>p]:fs-4xl [&>blockquote>p]:mb-8 [&>blockquote>p]:font-londrina-solid"
          >
            <StoryblokRichText :doc="blok?.description_right" />
          </div>
        </div>
      </div>
      <div class="mt-20">
        <header class="mb-20">
          <h4 class="text-chsc-indigo-500 fs-4xl font-londrina-solid mb-8 text-center">
            {{ blok?.cycle_title }}
          </h4>
        </header>
        <div class="overflow-x-auto">
          <div class="flex justify-center lg:justify-start w-[940px] l mx-auto overflow-hidden">
            <div class="inline-flex flex-wrap -mx-12">
              <div class="w-1/4 px-12 flex flex-col justify-center">
                <div class="me-cycle">
                  <div class="me-cycle__arrow bottom-full left-[70px] transform -translate-y-3">
                    <svg
                      width="155"
                      height="82"
                      viewBox="0 0 179 82"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M160 18H30C18.9543 18 10 26.9543 10 38V82"
                        stroke="#F8F3FF"
                        stroke-width="20"
                      />
                      <path
                        d="M160 33.5858L160 2.32247C160 1.44489 161.05 0.99293 161.687 1.596L177.753 16.7934C178.162 17.1805 178.171 17.8288 177.773 18.227L161.707 34.2929C161.077 34.9229 160 34.4767 160 33.5858Z"
                        fill="#F8F3FF"
                      />
                    </svg>
                  </div>
                  <div class="me-cycle__period">
                    {{ blok?.cycle_3_title }}
                  </div>
                  <div class="me-cycle__text">
                    {{ blok?.cycle_3_data }}
                  </div>
                  <div class="me-cycle__arrow top-full left-[70px] transform translate-y-3">
                    <svg
                      width="155"
                      height="72"
                      viewBox="0 0 178 72"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M178 62H38C26.9543 62 18 53.0457 18 42V18"
                        stroke="#F8F3FF"
                        stroke-width="20"
                      />
                      <path
                        d="M2.41421 18.5L33.6775 18.5C34.5551 18.5 35.0071 17.4503 34.404 16.8128L19.2066 0.746927C18.8195 0.337808 18.1712 0.328805 17.773 0.72702L1.70711 16.7929C1.07714 17.4229 1.52331 18.5 2.41421 18.5Z"
                        fill="#F8F3FF"
                      />
                    </svg>
                  </div>
                </div>
              </div>
              <div class="w-1/4 px-12 flex flex-col justify-between space-y-44">
                <div class="me-cycle">
                  <div class="me-cycle__period">
                    {{ blok?.cycle_4_title }}
                  </div>
                  <div class="me-cycle__arrow left-full top-[80px] transform translate-x-[5px]">
                    <svg
                      width="85"
                      height="36"
                      viewBox="0 0 97 36"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M78 18H0" stroke="#F8F3FF" stroke-width="20" />
                      <path
                        d="M78 33.5858L78 2.32247C78 1.44489 79.0497 0.99293 79.6872 1.596L95.7531 16.7934C96.1622 17.1805 96.1712 17.8288 95.773 18.227L79.7071 34.2929C79.0771 34.9229 78 34.4767 78 33.5858Z"
                        fill="#F8F3FF"
                      />
                    </svg>
                  </div>
                  <div class="me-cycle__text">
                    {{ blok?.cycle_4_data }}
                  </div>
                </div>
                <div class="me-cycle">
                  <div class="me-cycle__period">
                    {{ blok?.cycle_2_title }}
                  </div>
                  <div class="me-cycle__arrow transform left-full translate-x-[5px]">
                    <svg
                      width="85"
                      height="36"
                      viewBox="0 0 96 36"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M96 18H18" stroke="#F8F3FF" stroke-width="20" />
                      <path
                        d="M18.5 33.5858L18.5 2.32247C18.5 1.44489 17.4503 0.99293 16.8128 1.596L0.746928 16.7934C0.33781 17.1805 0.328807 17.8288 0.727022 18.227L16.7929 34.2929C17.4229 34.9229 18.5 34.4767 18.5 33.5858Z"
                        fill="#F8F3FF"
                      />
                    </svg>
                  </div>
                  <div class="me-cycle__text">
                    {{ blok?.cycle_2_data }}
                  </div>
                </div>
              </div>
              <div class="w-1/4 px-12 flex flex-col justify-between space-y-44">
                <div class="me-cycle">
                  <div class="me-cycle__period me-cycle__period--accent">
                    {{ blok?.cycle_5_title }}
                  </div>
                  <div class="me-cycle__text relative">
                    {{ blok?.cycle_5_data }}
                  </div>
                  <svg
                    width="60"
                    height="60"
                    viewBox="0 0 60 60"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    class="absolute -bottom-6 right-0"
                  >
                    <path
                      d="M15 37.5004C12.5136 37.5004 10.129 36.5127 8.37087 34.7545C6.61272 32.9964 5.625 30.6118 5.625 28.1254C5.625 25.639 6.61272 23.2544 8.37087 21.4963C10.129 19.7381 12.5136 18.7504 15 18.7504H24.375C24.375 18.7504 37.1371 18.7504 49.4182 8.45016C49.6914 8.22027 50.0244 8.07316 50.3783 8.02611C50.7322 7.97907 51.0922 8.03406 51.4159 8.1846C51.7396 8.33515 52.0136 8.575 52.2056 8.87595C52.3977 9.17689 52.4998 9.52642 52.5 9.88342V46.3674C52.4998 46.7244 52.3977 47.0739 52.2056 47.3748C52.0136 47.6758 51.7396 47.9156 51.4159 48.0662C51.0922 48.2167 50.7322 48.2717 50.3783 48.2247C50.0244 48.1776 49.6914 48.0305 49.4182 47.8006C37.1371 37.5004 24.375 37.5004 24.375 37.5004H15Z"
                      fill="white"
                      stroke="#9780BC"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M24.375 18.75V47.7465C24.375 48.0552 24.2988 48.3591 24.1531 48.6313C24.0075 48.9034 23.7969 49.1354 23.5401 49.3066L20.9638 51.0241C20.7138 51.1908 20.4274 51.295 20.1287 51.3278C19.83 51.3607 19.5279 51.3213 19.2476 51.2129C18.9673 51.1046 18.7172 50.9304 18.5183 50.7052C18.3194 50.48 18.1776 50.2103 18.1047 49.9188L15 37.5"
                      stroke="#9780BC"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
                <div class="me-cycle">
                  <div class="me-cycle__period">
                    {{ blok?.cycle_1_title }}
                  </div>
                  <div class="me-cycle__text">
                    {{ blok?.cycle_1_data }}
                  </div>
                </div>
              </div>
              <div class="w-1/4 px-12 flex flex-col justify-center">
                <div class="me-cycle">
                  <div class="me-cycle__arrow bottom-full right-[70px] transform -translate-y-3">
                    <svg
                      width="155"
                      height="73"
                      viewBox="0 0 178 73"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M0 10H140C151.046 10 160 18.9543 160 30V54"
                        stroke="#F8F3FF"
                        stroke-width="20"
                      />
                      <path
                        d="M144.414 54L175.678 54C176.555 54 177.007 55.0497 176.404 55.6872L161.207 71.7531C160.82 72.1622 160.171 72.1712 159.773 71.773L143.707 55.7071C143.077 55.0771 143.523 54 144.414 54Z"
                        fill="#F8F3FF"
                      />
                    </svg>
                  </div>
                  <div class="me-cycle__period">
                    {{ blok?.cycle_6_title }}
                  </div>
                  <div class="me-cycle__text">
                    {{ blok?.cycle_6_data }}
                  </div>
                  <div class="me-cycle__arrow top-full right-[70px] transform translate-y-3">
                    <svg
                      width="155"
                      height="73"
                      viewBox="0 0 178 73"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M18 55H148C159.046 55 168 46.0457 168 35V0"
                        stroke="#F8F3FF"
                        stroke-width="20"
                      />
                      <path
                        d="M18.5 70.5858L18.5 39.3225C18.5 38.4449 17.4503 37.9929 16.8128 38.596L0.746928 53.7934C0.33781 54.1805 0.328807 54.8288 0.727022 55.227L16.7929 71.2929C17.4229 71.9229 18.5 71.4767 18.5 70.5858Z"
                        fill="#F8F3FF"
                      />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </UiContainer>
    <UModal
      v-model:open="open"
      :ui="{
        content: 'border border-chsc-indigo-500',
      }"
      class="max-w-4xl sm:max-w-4xl rounded-[40px] overflow-hidden"
    >
      <template #content>
        <div>
          <header
            :class="[
              `py-3.5 pl-20 pr-6 border-b border-chsc-indigo-500 flex items-center justify-between`,
              { 'bg-chsc-indigo-500 text-white': true },
            ]"
          >
            <h3 class="fs-3xl font-eb-garamond font-medium">
              {{ blok?.privacy_modal_title }}
            </h3>
            <button
              class="flex items-center justify-center fs-xl cursor-pointer"
              @click="open = false"
            >
              <UIcon name="i-heroicons-x-mark" />
            </button>
          </header>
          <div class="p-20 max-h-[75vh] overflow-y-auto global-text">
            <StoryblokRichText :doc="blok?.privacy_modal_description" />
          </div>
        </div>
      </template>
    </UModal>
  </section>
</template>

<style></style>
